const objectUrlLifetimeMilliseconds = 60_000;

export function openPdf(pdf: Blob): void {
  const objectUrl = window.URL.createObjectURL(pdf);
  window.open(objectUrl, '_blank', 'noopener,noreferrer');
  window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), objectUrlLifetimeMilliseconds);
}

export function downloadPdf(pdf: Blob, fileName: string): void {
  const objectUrl = window.URL.createObjectURL(pdf);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 0);
}
